<template>
<crud-layout :title="title" :subtitle="subtitle">

        <template v-slot:list>
            <stock-transaction-list 
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"
            
            />
        </template>
        
         <add-button @click="create"></add-button>
      
        <stock-transaction-create v-if="creating" 
                        :open="creating"
                        v-on:itemCreated="onItemCreated" 
                        v-on:close="creating=false" 
        />
        
        <stock-transaction-update v-if="updating" 
                        :open="updating"
                        :item="itemToEdit" 
                        v-on:itemUpdated="onItemUpdated" 
                        v-on:close="updating=false" 
        />
          
        <stock-transaction-show v-if="showing" 
                           :open="showing" 
                           :item="itemToShow"  
                           v-on:close="showing=false" 
         />

        <stock-transaction-delete v-if="deleting" 
                         :open="deleting"
                         :item="itemToDelete"  
                         v-on:itemDeleted="onItemDeleted" 
                         v-on:close="deleting=false" 
        />

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>
    
    import StockTransactionCreate from "../StockTransactionCreate";
    import StockTransactionUpdate from "../StockTransactionUpdate";
    import StockTransactionDelete from "../StockTransactionDelete";
    import StockTransactionShow from "../StockTransactionShow";
    import StockTransactionList from "../StockTransactionList";
    
     import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"
     
    export default {
        name: "StockTransactionCrud",
        components: {
            CrudLayout, AddButton, Snackbar,
            StockTransactionCreate, 
            StockTransactionUpdate, 
            StockTransactionDelete, 
            StockTransactionShow,
            StockTransactionList
        },
        data() {
            return {
                title: 'delivery.stockTransaction.title',
                subtitle: 'delivery.stockTransaction.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= "common.created"
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= "common.updated"
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= "common.deleted"
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }
        
    }
</script>


